import React from "react";
import { CurrentBalanceCard } from "./CurrentBalanceCard";
import { CurrentBalanceInsightsPanel } from "./CurrentBalanceInsightsPanel";
import { useCurrentBalance } from "../../hooks/useCurrentBalance";
import { useCurrentBalanceInsights } from "../../hooks/useCurrentBalanceInsights";

export function CurrentBalanceSection() {
  const { card, loading, error } = useCurrentBalance();

  const insightsData = useCurrentBalanceInsights({
    enabled: !loading && !error,
  });

  const insightsMonthLabel =
    insightsData.monthLabel !== ""
      ? `${insightsData.monthLabel} · Insights`
      : card?.asOfLabel
        ? card.asOfLabel === "No closed months yet"
          ? "Insights"
          : `${card.asOfLabel} · Insights`
        : "Insights";

  const insightsPanelLoading = loading || insightsData.loading;
  const insightsToShow = insightsData.error ? [] : insightsData.insights;

  return (
    <div className="flex w-full flex-col items-start gap-4 rounded-lg bg-white px-6 py-6 shadow-sm">
      <div className="flex w-full gap-6 items-stretch">
        {error && !loading ? (
          <div className="flex flex-1 min-w-0 flex-col items-start justify-center rounded-lg border border-solid border-neutral-border bg-neutral-50 px-6 py-6">
            <span className="text-body-bold font-body-bold text-default-font">
              {error === "No data found" ? "No data found" : "Failed to load"}
            </span>
            <span className="text-caption font-caption text-subtext-color">
              {error === "No data found"
                ? "We couldn't find current balance data for this account."
                : "Please try again in a moment."}
            </span>
          </div>
        ) : (
          <CurrentBalanceCard
            loading={loading}
            asOfLabel={card?.asOfLabel}
            balanceAmount={card?.balanceAmount}
            balanceSubtitle={card?.balanceSubtitle}
            barHeights={card?.barHeights}
            barLabels={card?.barLabels}
            barAmounts={card?.barAmounts}
            momPercent={card?.momPercentLabel}
            runwayLabel={card?.runwayLabel}
          />
        )}
        <CurrentBalanceInsightsPanel
          monthLabel={insightsMonthLabel}
          insights={insightsToShow}
          loading={insightsPanelLoading}
        />
      </div>
    </div>
  );
}
